/**
 * Convenience wrapper: true iff the connected wallet is an owner of the current
 * Safe AND that Safe lives on a registry-enabled Seismic chain.
 *
 * Used to gate the reveal / send actions in row UI. The reader contract also
 * enforces this server-side via `ISafe(safe).isOwner(msg.sender)` (spec §16, P1)
 * — the client-side gate is UX-only.
 */
import useIsSafeOwner from '@/hooks/useIsSafeOwner'
import { useSrc20Config } from './useSrc20Config'

export const useIsSafeOwnerOnSeismic = (): boolean => {
  const isOwner = useIsSafeOwner()
  const cfg = useSrc20Config()
  return isOwner && !!cfg
}

export default useIsSafeOwnerOnSeismic
